
const SERVER_HOST = "https://cloudcalls.easipath.com/backend-pmis-woodchipping/api"
export {
    SERVER_HOST
}

export const AppName="pmis";
export const DbName="pmis"
